/**
 * @generated SignedSource<<430d029e19137695dff774d61b19b324>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProfilePromptsScreenQuery$variables = Record<PropertyKey, never>;
export type ProfilePromptsScreenQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ProfilePromptsView_query">;
};
export type ProfilePromptsScreenQuery = {
  response: ProfilePromptsScreenQuery$data;
  variables: ProfilePromptsScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "kind": "Literal",
  "name": "orderBy",
  "value": [
    "SEQUENCE_ASC"
  ]
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "question",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ProfilePromptsScreenQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "ProfilePromptsView_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ProfilePromptsScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Literal",
            "name": "filter",
            "value": {
              "deletedAt": {
                "isNull": true
              }
            }
          },
          (v0/*:: as any*/)
        ],
        "concreteType": "PromptConnection",
        "kind": "LinkedField",
        "name": "prompts",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Prompt",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "category",
                "storageKey": null
              },
              (v1/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "rowId",
                "storageKey": null
              },
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": "prompts(filter:{\"deletedAt\":{\"isNull\":true}},orderBy:[\"SEQUENCE_ASC\"])"
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              (v0/*:: as any*/)
            ],
            "concreteType": "UserPromptConnection",
            "kind": "LinkedField",
            "name": "userPrompts",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserPrompt",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "promptId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "answer",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Prompt",
                    "kind": "LinkedField",
                    "name": "prompt",
                    "plural": false,
                    "selections": [
                      (v1/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "deletedAt",
                        "storageKey": null
                      },
                      (v2/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v2/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "userPrompts(orderBy:[\"SEQUENCE_ASC\"])"
          },
          (v2/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "fb417e336eada8db6d46fcde2fe2617d",
    "id": null,
    "metadata": {},
    "name": "ProfilePromptsScreenQuery",
    "operationKind": "query",
    "text": "query ProfilePromptsScreenQuery {\n  ...ProfilePromptsView_query\n}\n\nfragment ProfilePromptsView_query on Query {\n  ...PromptSelectInput_query\n  ...useUserPrompts_query\n}\n\nfragment PromptSelectInput_query on Query {\n  prompts(filter: {deletedAt: {isNull: true}}, orderBy: [SEQUENCE_ASC]) {\n    nodes {\n      category\n      question\n      rowId\n      id\n    }\n  }\n}\n\nfragment useUserPrompts_query on Query {\n  currentUser {\n    userPrompts(orderBy: [SEQUENCE_ASC]) {\n      nodes {\n        promptId\n        answer\n        prompt {\n          question\n          deletedAt\n          id\n        }\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "7bf017afafe395182af8af37b8ff806b";

export default node;
